<template>
  <b-container>
  </b-container>
</template>

<script>

export default {
  name: "Factor",
}
</script>

<style scoped>

</style>